import { TEmployeeRenewVisaDocumentStepGroup } from "@/api/entities/employee-renew-visa-document-step-group.entity";
import { useGetRenewVisaApplicationResultInformationGroupList } from "@/api/services/main/renew-visa";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { AfterSubmitApplicationResultStepCard } from "@/features/renew-visa/components/afterSubmitApplicationResultStep/AfterSubmitApplicationResultStepCard";
import { FC } from "react";

export type TRenewVisaAfterSubmitApplicationResultStepProps = {
  stepGroupData: TEmployeeRenewVisaDocumentStepGroup;
  readonly: boolean;
  isExistBasicInfoData: boolean;
};

export const RenewVisaAfterSubmitApplicationResultStep: FC<TRenewVisaAfterSubmitApplicationResultStepProps> = ({
  stepGroupData,
  readonly,
  isExistBasicInfoData,
}) => {
  const { id: renewVisaDocumentStepGroupId } = stepGroupData;
  const {
    data: applicationInformationGroupListData,
    isLoading,
    isFetching,
  } = useGetRenewVisaApplicationResultInformationGroupList({
    renewVisaDocumentStepGroupId,
  });

  if (isLoading || isFetching) return <LoadingArea />;

  return (
    <AfterSubmitApplicationResultStepCard
      isExistBasicInfoData={isExistBasicInfoData}
      readonly={readonly}
      applicationResultInformationGroupListData={applicationInformationGroupListData ?? []}
      stepGroupData={stepGroupData}
    />
  );
};
